// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__ouxCO","large":"styles_large__pAFji"};